module.exports = __webpack_public_path__ + "static/img/zwyth_03.81896d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/zwyth_03.png
// module id = PF3H
// module chunks = 1